/// <reference types="./table.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $element from "../../../lustre/lustre/element.mjs";
import * as $html from "../../../lustre/lustre/element/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $paragraph from "../../data/docx/paragraph.mjs";
import * as $text from "../../data/docx/text.mjs";
import { Ok, Error, toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";

export class Table extends $CustomType {
  constructor(index, tag, rows, metadata) {
    super();
    this.index = index;
    this.tag = tag;
    this.rows = rows;
    this.metadata = metadata;
  }
}

export class Row extends $CustomType {
  constructor(index, is_header, cells) {
    super();
    this.index = index;
    this.is_header = is_header;
    this.cells = cells;
  }
}

export class Cell extends $CustomType {
  constructor(index, children, styles) {
    super();
    this.index = index;
    this.children = children;
    this.styles = styles;
  }
}

export class Text extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Paragraph extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}

export function to_html(table) {
  let _block;
  let $ = table.index;
  if ($ instanceof Some) {
    let i = $[0];
    _block = toList([$a.attribute("data-index", $int.to_string(i))]);
  } else {
    _block = toList([]);
  }
  let attributes = _block;
  return $element.element(
    table.tag,
    attributes,
    $list.map(
      table.rows,
      (row) => {
        let index = $a.attribute("data-index", $int.to_string(row.index));
        let _block$1;
        let $1 = row.is_header;
        if ($1) {
          _block$1 = $html.th;
        } else {
          _block$1 = $html.tr;
        }
        let node = _block$1;
        return node(
          toList([index]),
          $list.map(
            row.cells,
            (cell) => {
              let index$1 = $a.attribute(
                "data-index",
                $int.to_string(cell.index),
              );
              let styles = $list.map(
                cell.styles,
                (a) => { return $a.style(a[0], a[1]); },
              );
              return $html.td(
                listPrepend(index$1, styles),
                $list.map(
                  cell.children,
                  (content) => {
                    if (content instanceof Text) {
                      let t = content[0];
                      return $text.to_html(t);
                    } else {
                      let p = content[0];
                      return $paragraph.to_html(p);
                    }
                  },
                ),
              );
            },
          ),
        );
      },
    ),
  );
}

export function to_labelling(table) {
  let _block;
  let _pipe = table.metadata.kind;
  let _pipe$1 = $option.map(_pipe, $kind.to_string);
  let _pipe$2 = $option.map(
    _pipe$1,
    (_capture) => { return $a.attribute("kind", _capture); },
  );
  _block = $option.unwrap(_pipe$2, $a.none());
  let kind = _block;
  let content = to_html(table);
  let _block$1;
  let _pipe$3 = toList([kind]);
  let _block$2;
  let $ = table.index;
  if ($ instanceof Some) {
    let i = $[0];
    _block$2 = (_capture) => {
      return $list.prepend(
        _capture,
        $a.attribute("data-index", $int.to_string(i)),
      );
    };
  } else {
    _block$2 = $function.identity;
  }
  _block$1 = _block$2(_pipe$3);
  let attributes = _block$1;
  return $element.element("document-labeller", attributes, toList([content]));
}

function type_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "table") {
        return $decode.success(undefined);
      } else {
        return $decode.failure(undefined, "table");
      }
    },
  );
}

function cell_decoder() {
  return $decode.field(
    "index",
    $decode.int,
    (index) => {
      return $decode.optional_field(
        "children",
        toList([]),
        (() => {
          let _block;
          let _pipe = $paragraph.decoder();
          _block = $decode.map(_pipe, (var0) => { return new Paragraph(var0); });
          let _pipe$1 = _block;
          return $decode.list(_pipe$1);
        })(),
        (children) => {
          return $decode.optional_field(
            "cell_style",
            toList([]),
            (() => {
              let _pipe = $decode.dict($decode.string, $decode.string);
              return $decode.map(_pipe, $dict.to_list);
            })(),
            (styles) => {
              return $decode.success(new Cell(index, children, styles));
            },
          );
        },
      );
    },
  );
}

function row_decoder() {
  return $decode.field(
    "index",
    $decode.int,
    (index) => {
      return $decode.optional_field(
        "is_header",
        false,
        $decode.bool,
        (is_header) => {
          return $decode.optional_field(
            "cells",
            toList([]),
            $decode.list(cell_decoder()),
            (cells) => {
              return $decode.success(new Row(index, is_header, cells));
            },
          );
        },
      );
    },
  );
}

function encode_cell(cell) {
  return $json.object(
    toList([
      ["index", $json.int(cell.index)],
      [
        "children",
        $json.array(
          cell.children,
          (content) => {
            if (content instanceof Text) {
              let t = content[0];
              return $text.encode(t);
            } else {
              let p = content[0];
              return $paragraph.encode(p);
            }
          },
        ),
      ],
      [
        "cell_style",
        (() => {
          let _pipe = cell.styles;
          let _pipe$1 = $list.map(
            _pipe,
            (_capture) => { return $pair.map_second(_capture, $json.string); },
          );
          return $json.object(_pipe$1);
        })(),
      ],
    ]),
  );
}

function encode_row(row) {
  return $json.object(
    toList([
      ["index", $json.int(row.index)],
      ["is_header", $json.bool(row.is_header)],
      ["cells", $json.array(row.cells, encode_cell)],
    ]),
  );
}

export function encode(table) {
  return $json.object(
    toList([
      ["type", $json.string("table")],
      ["index", $json.nullable(table.index, $json.int)],
      ["html_tag", $json.string(table.tag)],
      ["rows", $json.array(table.rows, encode_row)],
      ["metadata", $json.object(toList([]))],
    ]),
  );
}

function metadata_decoder() {
  let decoder$1 = $decode.optional($kind.decoder());
  return $decode.optional_field(
    "kind",
    new None(),
    decoder$1,
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

function empty_metadata() {
  return new Metadata(new None());
}

export function decoder() {
  return $decode.field(
    "type",
    type_decoder(),
    (_) => {
      return $decode.field(
        "index",
        $decode.optional($decode.int),
        (index) => {
          return $decode.field(
            "html_tag",
            $decode.string,
            (tag) => {
              return $decode.optional_field(
                "rows",
                toList([]),
                $decode.list(row_decoder()),
                (rows) => {
                  return $decode.optional_field(
                    "metadata",
                    empty_metadata(),
                    metadata_decoder(),
                    (metadata) => {
                      return $decode.success(
                        new Table(index, tag, rows, metadata),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function flatten_tree(el) {
  if (el instanceof $html_parser.StartElement) {
    let children = el.children;
    return listPrepend(
      el,
      (() => {
        let _pipe = children;
        return $list.flat_map(_pipe, flatten_tree);
      })(),
    );
  } else {
    return toList([]);
  }
}

export function from_html_string(html) {
  let _block;
  let $ = $string.starts_with(html, "<");
  if ($) {
    _block = html;
  } else {
    _block = ("<table>" + html) + "</table>";
  }
  let html$1 = _block;
  let _block$1;
  let _pipe = $string.trim(html$1);
  _block$1 = $string.starts_with(_pipe, "<table");
  let is_table = _block$1;
  return $bool.guard(
    !is_table,
    new Error(undefined),
    () => {
      let root = $html_parser.as_tree(html$1);
      let _block$2;
      let _pipe$1 = $html_parser.extract_attribute("data-index", root);
      let _pipe$2 = $option.map(
        _pipe$1,
        (i) => {
          let _pipe$2 = $int.parse(i);
          return $option.from_result(_pipe$2);
        },
      );
      _block$2 = $option.flatten(_pipe$2);
      let index = _block$2;
      let _block$3;
      let _pipe$3 = root;
      let _pipe$4 = flatten_tree(_pipe$3);
      _block$3 = $list.filter_map(
        _pipe$4,
        (el) => {
          if (el instanceof $html_parser.StartElement) {
            let $1 = el.name;
            if ($1 === "tr") {
              let tr = el;
              return new Ok(tr);
            } else {
              return new Error(undefined);
            }
          } else {
            return new Error(undefined);
          }
        },
      );
      let trs = _block$3;
      let _block$4;
      let _pipe$5 = trs;
      _block$4 = $list.index_map(
        _pipe$5,
        (row_el, ri) => {
          let _block$5;
          if (row_el instanceof $html_parser.StartElement) {
            let row_children = row_el.children;
            let _pipe$6 = row_children;
            _block$5 = $list.filter_map(
              _pipe$6,
              (cell_el) => {
                if (cell_el instanceof $html_parser.StartElement) {
                  let $1 = cell_el.name;
                  if ($1 === "td") {
                    let cattrs = cell_el.attributes;
                    let cchildren = cell_el.children;
                    let _block$6;
                    let _pipe$7 = cattrs;
                    _block$6 = $list.filter_map(
                      _pipe$7,
                      (attr) => {
                        let $2 = attr.key;
                        if ($2 === "data-index") {
                          let v = attr.value;
                          let $3 = $int.parse(v);
                          if ($3 instanceof Ok) {
                            let ci = $3[0];
                            return new Ok(ci);
                          } else {
                            return new Error(undefined);
                          }
                        } else {
                          return new Error(undefined);
                        }
                      },
                    );
                    let cids = _block$6;
                    let _block$7;
                    let $2 = $list.first(cids);
                    if ($2 instanceof Ok) {
                      let first = $2[0];
                      _block$7 = first;
                    } else {
                      _block$7 = ri;
                    }
                    let cindex = _block$7;
                    let _block$8;
                    let _pipe$8 = cchildren;
                    _block$8 = $list.filter_map(
                      _pipe$8,
                      (grand) => {
                        if (grand instanceof $html_parser.StartElement) {
                          let $3 = grand.name;
                          if ($3 === "p") {
                            let p = grand;
                            let _pipe$9 = $paragraph.from_html_string(
                              $html_parser.render_html(p),
                            );
                            return $result.map(
                              _pipe$9,
                              (par) => { return new Paragraph(par); },
                            );
                          } else {
                            return new Error(undefined);
                          }
                        } else if (grand instanceof $html_parser.Content) {
                          let txt = grand[0];
                          return new Ok(
                            new Text(new $text.Text(txt, toList([]))),
                          );
                        } else {
                          return new Error(undefined);
                        }
                      },
                    );
                    let contents = _block$8;
                    return new Ok(new Cell(cindex, contents, toList([])));
                  } else if ($1 === "th") {
                    let cattrs = cell_el.attributes;
                    let cchildren = cell_el.children;
                    let _block$6;
                    let _pipe$7 = cattrs;
                    _block$6 = $list.filter_map(
                      _pipe$7,
                      (attr) => {
                        let $2 = attr.key;
                        if ($2 === "data-index") {
                          let v = attr.value;
                          let $3 = $int.parse(v);
                          if ($3 instanceof Ok) {
                            let ci = $3[0];
                            return new Ok(ci);
                          } else {
                            return new Error(undefined);
                          }
                        } else {
                          return new Error(undefined);
                        }
                      },
                    );
                    let cids = _block$6;
                    let _block$7;
                    let $2 = $list.first(cids);
                    if ($2 instanceof Ok) {
                      let first = $2[0];
                      _block$7 = first;
                    } else {
                      _block$7 = ri;
                    }
                    let cindex = _block$7;
                    let _block$8;
                    let _pipe$8 = cchildren;
                    _block$8 = $list.filter_map(
                      _pipe$8,
                      (grand) => {
                        if (grand instanceof $html_parser.StartElement) {
                          let $3 = grand.name;
                          if ($3 === "p") {
                            let p = grand;
                            let _pipe$9 = $paragraph.from_html_string(
                              $html_parser.render_html(p),
                            );
                            return $result.map(
                              _pipe$9,
                              (par) => { return new Paragraph(par); },
                            );
                          } else {
                            return new Error(undefined);
                          }
                        } else if (grand instanceof $html_parser.Content) {
                          let txt = grand[0];
                          return new Ok(
                            new Text(new $text.Text(txt, toList([]))),
                          );
                        } else {
                          return new Error(undefined);
                        }
                      },
                    );
                    let contents = _block$8;
                    return new Ok(new Cell(cindex, contents, toList([])));
                  } else {
                    return new Error(undefined);
                  }
                } else {
                  return new Error(undefined);
                }
              },
            );
          } else {
            _block$5 = toList([]);
          }
          let cells = _block$5;
          return new Row(ri, false, cells);
        },
      );
      let rows = _block$4;
      return new Ok(new Table(index, "table", rows, new Metadata(new None())));
    },
  );
}
